/**
 * Enumeration of icons to be used in the error page
 */
export enum MessageIcon {
  CROSS = "cross",
  GENERIC = "generic",
  INFO = "info",
  LOCK = "lock",
  MAINTENANCE = "maintenance",
  SHIELD = "shield",
  SUCCESS = "success",
  WIFI = "wifi",
  UPDATE = "update",
  HEARTBREAK = "heartbreak"
}
